import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {firstValueFrom} from "rxjs";

@Injectable()
export class DownloadService {

  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  downloadFile(fileId: string): Promise<HttpResponse<string>> {
    let url = `/upload/file/download/${fileId}`;
    return firstValueFrom(this.http.get(url, {observe: 'response', responseType: 'text'}))
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred while downloading', error);
    return Promise.reject(error.message || error);
  }
}
